<template>
  <div class="wrapper">
    <md-list :md-expand-single="true">
      <md-list-item
        v-for="item of menuItems"
        :key="item.title"
        md-expand
        :md-expanded="expanded(item.title)"
      >
        <md-subheader>{{ L(item.title) | upper }}</md-subheader>

        <md-list slot="md-expand">
          <md-list-item
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="
              '/' +
              item.title.toLowerCase() +
              '/' +
              subItem.to.replace(/ /g, '_').toLowerCase()
            "
          >
            <fa-icon :icon="subItem.icon" :brands="subItem.brands" />
            <span class="md-list-item-text">{{ L(subItem.title) }}</span>
          </md-list-item>
        </md-list>
      </md-list-item>
    </md-list>
    <div class="fixed" v-if="accessibleRoles" @click="goToAdmin">
      <div>{{ L('admin') | upper }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config'

export default {
  data: () => ({
    langKey: 'menu',
    permissions: [],
  }),
  created() {
    this.menuCategory = sessionStorage.getItem('menuCategory') || 'billing'
  },
  computed: {
    ...mapState({
      menu: (state) => state.menu,
      userInfo: (state) => state.userInfo,
    }),

    menuCategory: {
      get() {
        return sessionStorage.getItem('menuCategory') || 'billing'
      },
      set(value) {
        sessionStorage.setItem('menuCategory', value)
      },
    },

    menuItems() {
      if (this.userInfo.roles) {
        return this.menu.items
          .filter((item) => {
            if (item.platforms) {
              return item.platforms.includes(this.$platform.id)
            }
            return (
              !item.roles ||
              this.userInfo.roles.some((r) => item.roles.includes(r))
            )
          })
          .map((item) => ({
            title: item.title,
            items: item.items.filter(
              (elem) =>
                this.enabled(item.title, elem.title) &&
                (!elem.roles ||
                  this.userInfo.roles.some((r) => item.roles.includes(r)))
            ),
          }))
      }
      return null
    },

    admin() {
      return this.userInfo.admin
    },

    reseller() {
      return this.userInfo.reseller && this.userInfo.reseller.admin
    },

    accountant() {
      return this.userInfo.accountant
    },

    support() {
      return this.userInfo.support
    },

    admin_viewer() {
      return this.userInfo.admin_viewer
    },

    accountant_viewer() {
      return this.userInfo.accountant_viewer
    },

    tax_invoice_issuance_admin() {
      return this.userInfo.tax_invoice_issuance_admin
    },

    sales_manager_leader() {
      return this.userInfo.sales_manager_leader
    },

    sales_manager() {
      return this.userInfo.sales_manager
    },

    accessibleRoles() {
      if (!this.userInfo.role_names) return false
      return (
        this.admin ||
        this.reseller ||
        this.accountant ||
        this.support ||
        this.admin_viewer ||
        this.accountant_viewer ||
        this.sales_manager_leader ||
        this.sales_manager ||
        this.userInfo.role_names.includes('accountant_sales_adjustment') ||
        this.userInfo.role_names.includes('tax_invoice_issuance_admin') ||
        this.userInfo.role_names.some((role) => role.startsWith('admin_'))
      )
    },
  },

  methods: {
    expanded(title) {
      if (this.$route) {
        const tokens = this.$route.path.split('/')
        if (tokens.length > 1) {
          return title === this.$route.path.split('/')[1]
        }
      }
      return false
    },

    enabled(category, name) {
      if (
        this.$config[category] === undefined ||
        this.$config[category][name] === undefined ||
        this.$config[category][name].enabled === undefined
      ) {
        return true
      }

      return this.$config[category][name].enabled
    },

    goToAdmin() {
      const base = config.admin.root || `//${window.location.host}/admin/`
      let target = ''

      if (
        this.userInfo.admin ||
        this.userInfo.admin_viewer ||
        this.userInfo.role_names.some((role) => role.includes('admin_'))
      ) {
        this.menuCategory = 'mgmt'
        target = base
      } else if (
        this.userInfo.tax_invoice_issuance_admin ||
        this.userInfo.support
      ) {
        this.menuCategory = 'accounting'
        target = `${base}accounting/TaxInvoiceIssuance`
      } else if (this.userInfo.reseller && this.userInfo.reseller.admin) {
        this.menuCategory = 'reseller'
        target = `${base}reseller/ResellerDashboard`
      } else if (this.userInfo.accountant) {
        this.menuCategory = 'accounting'
        target = `${base}accounting/SalesSummary`
      } else if (this.userInfo.accountant_viewer) {
        this.menuCategory = 'accounting'
        target = `${base}accounting/dashboard`
      } else if (this.userInfo.sales_manager_leader) {
        this.menuCategory = 'salesDashboard'
        target = `${base}salesDashboard/gcp/SalesAnalysis`
      } else if (this.userInfo.sales_manager) {
        this.menuCategory = 'salesManagerDashboard'
        target = `${base}salesDashboard/gcp/CustomerAnalysis`
      } else if (
        this.userInfo.role_names.includes('accountant_sales_adjustment')
      ) {
        this.menuCategory = 'accounting'
        target = `${base}accounting/SalesAdjustment`
      } else {
        target = base
      }

      localStorage.setItem('user/info', JSON.stringify(this.userInfo))
      window.location.href = target
    },
  },
  watch: {},
}
</script>

<style scoped>
.md-list-item-text {
  white-space: normal;
}
.md-list {
  padding: 0;
}

.wrapper {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 60px;
}

.fixed {
  font-weight: bold;
  position: fixed;
  bottom: 0;
  z-index: 100;
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
